const formatStatus = function (status: number) {
  switch (status) {
    case 0:
      return '未开始'
    case 1:
      return '进行中'
    case 2:
      return '已完成'
    case -1:
      return '已关闭'
    default:
      return '未开始'
  }
}

const TradeType = function (type: string) {
  switch (type) {
    case '充值':
      return '余额充值'
    case '代充':
      return '手动充值'
    case '扣缴':
      return '扣除余额'
    case '退款':
      return '用户退款'
    case '消费':
      return '用户消费'
  }
}

const formatStatusClass = function (status: number) {
  switch (status) {
    case 0:
      return 'pendingStatus'
    case 1:
      return 'recoveryStatus'
    case 2:
      return 'finishStatus'
    case -1:
      return 'rejectStatus'
    default:
      return 'pendingStatus'
  }
}

const settlementStatus = function (status:number){
  switch (status){
    case 0:
      return '未结算'
    case 1:
      return '已结算'
    default:
      return '未结算'
  }
}

const contentStatus = function (status: number) {
  switch (status) {
    case 0:
      return '关闭'
    case 1:
      return '正常'
    default:
      return '关闭'
  }
}

const formatImgUrl = function (url: string | undefined) {
  if (!url) return ''
  if (process.env.NODE_ENV === 'development') {
    return 'http://66.45.253.206:890' + url
  } else {
    return url
  }
}

export default {
  formatStatus,
  formatStatusClass,
  contentStatus,
  formatImgUrl,
  TradeType,
  settlementStatus
}
